import {useEffect, useState} from 'react'
import {KTIcon} from "../../../../_metronic/helpers";
import clsx from "clsx";
import axios from "axios";
import {toast} from "react-toastify";


const TopUpModal = ({ data, onClose, fetchApiUsage, formatNumber }) => {
    const [amount, setAmount] = useState('')
    const [isLoading, setLoading] = useState(false)

    useEffect(() => {
        document.body.classList.add('modal-open')
        return () => {
            document.body.classList.remove('modal-open')
        }
    }, [])

    const handleTopUp = async () => {
        try {
            setLoading(true)
            await axios.post(`${process.env.REACT_APP_API_V3_URL}/partner/${data.partner_id}/topup`, {
                limit: amount
            });
            toast.success('Partners API limit increased successfully');
            await fetchApiUsage()
            onClose()
        } catch (err) {
            toast.error(err?.response?.data?.message || 'Error while adding partners API usages');
        } finally {
            setLoading(false)
        }
    }

    return (
        <>
            <div
                className='modal fade show d-block'
                id='kt_modal_add_user'
                role='dialog'
                tabIndex={-1}
                aria-modal='true'
            >
                <div className={`modal-dialog modal-dialog-centered mw-550px`}>
                    <div className='modal-content'>
                        <div className='modal-header'>
                            <h2 className='fw-bolder'>Increase/Decrease API limit for {data.name}</h2>
                            <div
                                className='btn btn-icon btn-sm btn-active-icon-primary'
                                data-kt-users-modal-action='close'
                                onClick={onClose}
                                style={{cursor: 'pointer'}}
                            >
                                <KTIcon iconName='cross' className='fs-1' />
                            </div>
                        </div>

                        <div className={`modal-body scroll-y mx-5  mx-xl-5`}>
                            <div
                                className="d-flex flex-column me-n7 pe-7"
                                style={{ height: 'auto', maxHeight: '380px' }}
                                id="kt_modal_add_user_scroll"
                                data-kt-scroll="true"
                                data-kt-scroll-activate="{default: false, lg: true}"
                                data-kt-scroll-max-height="auto"
                                data-kt-scroll-dependencies="#kt_modal_add_user_header"
                                data-kt-scroll-wrappers="#kt_modal_add_user_scroll"
                                data-kt-scroll-offset="300px"
                            >
                                <div>
                                    <div className='mb-3 fw-bolder fs-4'>Current API Limit:</div>
                                    <div style={{
                                        backgroundColor: 'rgb(192, 192, 192)',
                                        borderRadius: 15,
                                        position: 'relative',
                                        height: 20,
                                        overflow: 'hidden',
                                    }}>
                                        <div
                                            style={{
                                                width: `${data.used / data.usage_limit * 100}%`,
                                                height: '100%',
                                                backgroundColor: 'rgb(116, 194, 92)',
                                                borderRadius: 15
                                            }}
                                        />
                                        <div
                                            style={{
                                                position: 'absolute',
                                                top: 0,
                                                left: 0,
                                                width: '100%',
                                                height: '100%',
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                color: '#fff'
                                            }}
                                        >
                                            {formatNumber(data.used)} / {formatNumber(data.usage_limit)}
                                        </div>
                                    </div>
                                </div>
                                <label className="fw-bold fs-6 mt-6">Increase/Decrease API Usage Limit by</label>
                                <input
                                    placeholder="Enter Value"
                                    className={clsx(
                                        "form-control form-control-solid mb-lg-0 mt-2"
                                    )}
                                    style={{
                                        width: "100%"
                                    }}
                                    required
                                    value={amount}
                                    onChange={(e) => {
                                    const value = e.target.value
                                    const allowNegativeRegex = /^[+-]?(0|[1-9]\d*)?$/
                                    if (allowNegativeRegex.test(value)) {
                                        const newLimit = data?.usage_limit + Number(value)
                                        if (newLimit < 0) {
                                            return toast.error('API limit cannot be negative')
                                        }
                                        setAmount(value)
                                    }
                                }}
                                />
                                <button
                                    className="btn btn-success mt-6"
                                    onClick={handleTopUp}
                                    disabled={isLoading || !amount}
                                >
                                    Increase/Decrease API Limit
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='modal-backdrop fade show'></div>
        </>
    )
}

export {TopUpModal}
